import {TranslationObject} from '@colonist/i18n'
import {CardEnum, CardTypeEnum, TurnState} from '@colonist/game-states'

export enum CardClickPopupType {
    None,
    NormalClick,
    TradeWindow,
    InformationPopup,
    ConfirmationPopup,
}

export abstract class BaseCardData {
    abstract readonly cardEnum: CardEnum
    abstract readonly cardTypeEnum: CardTypeEnum
    abstract readonly isCardBack: boolean
    abstract readonly imageFileName: string
    abstract readonly tipTitle: TranslationObject
    abstract readonly tipBody: TranslationObject
    abstract readonly clickPopupType: CardClickPopupType
    abstract readonly popupBody: TranslationObject
    abstract readonly allowableTurnStates: TurnState[] | undefined

    getNewInstanceOfData(): BaseCardData {
        /* eslint-disable @typescript-eslint/prefer-function-type */
        const newInstance = new (this.constructor as {new (): BaseCardData})()
        Object.assign(newInstance.tipTitle, this.tipTitle)
        Object.assign(newInstance.tipBody, this.tipBody)
        if(newInstance.popupBody != undefined) Object.assign(newInstance.popupBody, this.popupBody)
        return newInstance
    }
}

